import { render } from "./AccountForm.vue?vue&type=template&id=39e24262"
import script from "./AccountForm.vue?vue&type=script&lang=js"
export * from "./AccountForm.vue?vue&type=script&lang=js"
script.render = render

export default script